export enum ButtonTypes {
  Default = 'default',
  TextOnly = 'textOnly',
  IconOnly = 'iconOnly',
}

export enum IconPositions {
  Left = 'left',
  Right = 'right',
}

export enum NavigationLevels {
  Top = 'top',
  Header = 'header',
  Sub = 'sub',
  Footer = 'footer',
  Breadcrumb = 'breadcrumb',
}

export enum SocialActions {
  LinkClick = 'link click',
  Share = 'share',
}
